import React, { useState, useEffect } from "react";
import SolutionHeader from "./components/SolutionHeader";
import SolutionTabs from "./components/SolutionTabs";
import SolutionDetail from "./components/SolutionDetail";
import { solutionData } from "./components/solutionData";
import bgImage from "../../../images/main/main9.jpg";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

import '../../../custom/swiper.css';

const SolutionPage = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    const handleTabClick = (index) => {
        setActiveIndex(index);
    }

    // 탭 이동 핸들러 (prev/next)
    const handleTabChange = (direction) => {
        if (direction === 'prev') {
            setActiveIndex(prevIndex => prevIndex === 0 ? solutionData.length - 1 : prevIndex - 1);
        } else if (direction === 'next') {
            setActiveIndex(prevIndex => prevIndex === solutionData.length - 1 ? 0 : prevIndex + 1);
        }
    };

    // 화살표 키로 탭 이동 기능
    useEffect(() => {
        const handleKeyDown = (e) => {
            switch(e.key) {
                case 'ArrowRight':
                    e.preventDefault();
                    handleTabChange('next');
                    break;
                case 'ArrowLeft':
                    e.preventDefault();
                    handleTabChange('prev');
                    break;
                case ' ': // 스페이스바로 다음 탭
                    e.preventDefault();
                    handleTabChange('next');
                    break;
                default:
                    break;
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    return (
        <div
            className="w-full min-h-screen bg-no-repeat bg-cover relative flex flex-col"
            style={{ backgroundImage: `url(${bgImage})`, margin: 0, padding: 0 }}
        >
            {/* 키보드 컨트롤 안내 */}
            <div className="absolute top-2 sm:top-4 right-2 sm:right-4 z-50">
                <div className="bg-black/70 backdrop-blur-md rounded-lg px-2 sm:px-3 py-1 sm:py-2 shadow-lg text-white text-xs sm:text-sm space-y-1">
                    <div>키보드 조작: ← → Space Bar</div>
                    <div>현재: {activeIndex + 1} / {solutionData.length}</div>
                </div>
            </div>

            <div className="flex flex-col lg:flex-row items-center justify-center w-full flex-1">
                <div className="space-y-2 sm:space-y-4 lg:space-y-8 w-full max-w-full lg:max-w-[1200px] px-1 sm:px-2 md:px-4 lg:px-0 -mt-4 sm:-mt-6 lg:-mt-0">
                    <div className="flex flex-col lg:flex-row justify-between items-center w-full gap-2 lg:gap-4">
                        <SolutionHeader />

                        <SolutionTabs 
                            solutions={solutionData}
                            activeIndex={activeIndex}
                            onTabClick={handleTabClick}
                        />
                    </div>
                    
                    <SolutionDetail 
                        solutions={solutionData}
                        activeIndex={activeIndex}
                        onTabChange={handleTabChange}
                    />
                </div>
            </div>  
        </div>
    );
};

export default SolutionPage;